import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

const allowedFields = ['description', 'watch_lists']
const output = `
    id
    created_at
    updated_at
    description
    watch_lists {
        item_tag_stat_watch {
            id
            description
            tags
        }
    }
`

export default config => {
  const { client } = config
  const service = createService({
    ...config,
    table: 'item_tag_stat_report',
    defaultPageSize: 25,
    defaultOrderBy: [{ description: 'asc' }],
    defaultSearchBy: ['description'],
    defaultFilters: [],
    uniqueFields: [],
    defaultOutput: output,
    allowedFields
  })

  return {
    ...service,
    updateWatchLists: async payload => {
      const { reportId, watchLists } = payload

      const mutation = gql`
        mutation (
          $objects: [item_tag_stat_report_watch_list_insert_input!]!
          $reportId: uuid!
        ) {
          delete_item_tag_stat_report_watch_list(
            where: { item_tag_stat_report_id: { _eq: $reportId } }
          ) {
            affected_rows
          }
          insert_item_tag_stat_report_watch_list(
            objects: $objects
            on_conflict: { constraint: item_tag_stat_report_watch_lists_pkey }
          ) {
            affected_rows
          }
        }
      `

      const {
        data: { insert_item_tag_stat_report_watch_list: affected_rows }
      } = await client.mutate({
        mutation,
        variables: {
          reportId,
          objects: watchLists.map(a => ({
            item_tag_stat_report_id: reportId,
            item_tag_stat_watch_id: a.id
          }))
        }
      })

      console.log(affected_rows, watchLists.length, 'updateWatchLists')

      return affected_rows == watchLists.length
    }
  }
}
